import { useEffect, useState, useMemo, useCallback } from "react";
import WebSocketManager from "../../../../ws/client";

export function useEmployeeLiveUpdate(initialClient) {
  const [liveClient, setLiveClient] = useState(initialClient);

  useEffect(() => {
    setLiveClient(initialClient);
  }, [initialClient]);

  const employeeId = useMemo(() => {
    return initialClient?.id || initialClient?.id_employee;
  }, [initialClient]);

  const topic = useMemo(() => {
    if (!employeeId) return null;
    return `/topic/employee-${employeeId}`;
  }, [employeeId]);

  const handleMessage = useCallback((event) => {
    try {
      const { type, payload } = event;

      if (type === "UPDATED" && payload) {
        setLiveClient(payload);
      }

    } catch (err) {
      console.error("Erro ao processar update live do colaborador:", err);
    }
  }, []);

  useEffect(() => {
    if (!topic) return;
    WebSocketManager.subscribe(topic, handleMessage);

    return () => {
      WebSocketManager.unsubscribe(topic);
    };
  }, [topic, handleMessage]);

  return liveClient;
}